

















































































































import { Component, Vue } from "vue-property-decorator"

import EventsMenu from "./EventsMenu.vue"
import GameBackground from "./GameBackground.vue"
import GameOverScreen from "./GameOverScreen.vue"
import { rounds } from "../game_content/rounds"
import MoneyView from "./MoneyView.vue"
import GameMetaDataView from "./GameMetaDataView.vue"
import PowerView from "./PowerView.vue"
import BuyMenu from "./BuyMenu.vue"
import ResourceHandbook from "./ResourceHandbook.vue"
import PowerInfo from "./PowerInfo.vue"
import Tutorial from "./Tutorial.vue"
import FirstLoad from "./FirstLoad.vue"
import Overview from "./Overview.vue"
import PauseMenu from "./PauseMenu.vue"

@Component({
  components: {
    GameBackground,
    EventsMenu,
    GameOverScreen,
    MoneyView,
    GameMetaDataView,
    PowerView,
    FirstLoad,
    PowerInfo,
    BuyMenu,
    ResourceHandbook,
    Tutorial,
    Overview,
    PauseMenu
  }
})
export default class GameScreen extends Vue {
  // Decorators: https://github.com/kaorun343/vue-property-decorator
  // Class: https://github.com/vuejs/vue-class-component
  protected showPopup: boolean = true
  protected closePopup() {
    this.showPopup = false
  }
  protected mounted() {
    this.$store.commit("RETRIEVE_MARKDOWN", rounds())
  }

  get introScreen() {
    return this.$store.state.introScreen
  }

  get gameSpeed() {
    return this.$store.state.roundSpeed
  }

  get roundActive() {
    return this.$store.state.roundActive
  }

  get tutorialActive() {
    return this.$store.state.tutorial
  }

  get showOverview() {
    return this.$store.state.showOverview
  }

  get event() {
    return this.$store.getters.event
  }

  get gameOver() {
    return this.$store.getters.isGameOver
  }

  get firstLoad() {
    return this.$store.state.firstLoad
  }

  protected modGameSpeed(val: boolean) {
    this.$store.dispatch("modGameSpeed", val)
  }

  protected hurry() {
    this.$store.dispatch("nullTimer")
  }

  protected start() {
    if (!this.$store.state.muted) {
      new Howl({
        src: ["/audio/Click.mp3"]
      }).play()
    }
    this.$store.dispatch("beginRound")
  }
  
  protected begin() {
    if (!this.$store.state.muted) {
      new Howl({
        src: ["/audio/Click.mp3"]
      }).play()
    }
    this.$store.dispatch("startGame")
  }
}
